import type { TechMeasureTextContentData, TechMeasuresProjectCard } from '@/types';

export const isTextContentEmpty = (field?: TechMeasureTextContentData) =>
  !field || (field.text.length === 0 && field.image?.length === 0);

export const sortMeasuresProjects = (fieldToSort: string, projects: TechMeasuresProjectCard[], ascending: boolean) => {
  return projects.sort((a, b) => {
    const aValue = a[fieldToSort];
    const bValue = b[fieldToSort];

    const isEmptyValue = (value: any) => {
      return value === null || value === undefined || value === '';
    };

    if (isEmptyValue(aValue)) return 1;
    if (isEmptyValue(bValue)) return -1;

    if (ascending) {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });
};


export const transformPropertyToIndex = (property: string) =>
  property.toLowerCase().replace(/ /g, '-');
